// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3aDc8","Label":"BuildControl_Label__1Z5w5","Less":"BuildControl_Less__RSFVZ","More":"BuildControl_More__1a2O-"};